// This file is autogenerated. DO NOT MODIFY

export const INTEGRATIONS_ICONS = {
  Adobe: 'integrations-adobe',
  AfterEffects: 'integrations-after-effects',
  Airbnb: 'integrations-airbnb',
  AlfaBank: 'integrations-alfa-bank',
  Amazon: 'integrations-amazon',
  Amd: 'integrations-amd',
  Amex: 'integrations-amex',
  Android: 'integrations-android',
  Angellist: 'integrations-angellist',
  Angular: 'integrations-angular',
  AppStore: 'integrations-app-store',
  Appearin: 'integrations-appearin',
  AppleMusic: 'integrations-apple-music',
  Apple: 'integrations-apple',
  Asana: 'integrations-asana',
  Askfm: 'integrations-askfm',
  Atlassian: 'integrations-atlassian',
  Atom: 'integrations-atom',
  Autodesk: 'integrations-autodesk',
  Badoo: 'integrations-badoo',
  Bamboo: 'integrations-bamboo',
  Basecamp: 'integrations-basecamp',
  Behance: 'integrations-behance',
  Bitbucket: 'integrations-bitbucket',
  Blackberry: 'integrations-blackberry',
  Bluetooth: 'integrations-bluetooth',
  CPlusPlus: 'integrations-c-plus-plus',
  CSharp: 'integrations-c-sharp',
  ChromeOs: 'integrations-chrome-os',
  Chrome: 'integrations-chrome',
  Clion: 'integrations-clion',
  Codepen: 'integrations-codepen',
  Confluence: 'integrations-confluence',
  Coub: 'integrations-coub',
  Css3: 'integrations-css3',
  Datagrip: 'integrations-datagrip',
  Dell: 'integrations-dell',
  DirectDebit: 'integrations-direct-debit',
  Discord: 'integrations-discord',
  Docker: 'integrations-docker',
  Dreamweaver: 'integrations-dreamweaver',
  Dribbble: 'integrations-dribbble',
  Dropbox: 'integrations-dropbox',
  Drupal: 'integrations-drupal',
  Edge: 'integrations-edge',
  Elementary: 'integrations-elementary',
  Envato: 'integrations-envato',
  Evernote: 'integrations-evernote',
  Excel: 'integrations-excel',
  Facebook: 'integrations-facebook',
  Facetime: 'integrations-facetime',
  Fedora: 'integrations-fedora',
  Figma: 'integrations-figma',
  Finder: 'integrations-finder',
  Firefox: 'integrations-firefox',
  Flickr: 'integrations-flickr',
  Flowmapp: 'integrations-flowmapp',
  Foursquare: 'integrations-foursquare',
  Framer: 'integrations-framer',
  Freebsd: 'integrations-freebsd',
  GCalendar: 'integrations-g-calendar',
  GeneralElectric: 'integrations-general-electric',
  Git: 'integrations-git',
  Github: 'integrations-github',
  Gitlab: 'integrations-gitlab',
  Gmail: 'integrations-gmail',
  Gnome: 'integrations-gnome',
  Go: 'integrations-GO',
  GoogleAds: 'integrations-google-ads',
  GoogleDocs: 'integrations-google-docs',
  GoogleDrive: 'integrations-google-drive',
  GoogleHangouts: 'integrations-google-hangouts',
  GoogleMaps: 'integrations-google-maps',
  GoogleMeet: 'integrations-google-meet',
  GooglePlayMusic: 'integrations-google-play-music',
  GooglePlay: 'integrations-google-play',
  Google: 'integrations-google',
  Grooveshark: 'integrations-grooveshark',
  Html5: 'integrations-html5',
  Ibm: 'integrations-ibm',
  Ie: 'integrations-IE',
  Igtv: 'integrations-igtv',
  Illustrator: 'integrations-illustrator',
  Indesign: 'integrations-indesign',
  Instagram: 'integrations-instagram',
  Intel: 'integrations-intel',
  Intercom: 'integrations-intercom',
  Invision: 'integrations-invision',
  Ios: 'integrations-ios',
  Java: 'integrations-java',
  JbAppcode: 'integrations-jb-appcode',
  JbDotcover: 'integrations-jb-dotcover',
  JbDotmemory: 'integrations-jb-dotmemory',
  JbDotpeek: 'integrations-jb-dotpeek',
  JbDottrace: 'integrations-jb-dottrace',
  JbGoland: 'integrations-jb-goland',
  JbHub: 'integrations-jb-hub',
  JbIntellijIdea: 'integrations-jb-intellij-idea',
  JbKotlin: 'integrations-jb-kotlin',
  JbPhpstorm: 'integrations-jb-phpstorm',
  JbPycharmEdu: 'integrations-jb-pycharm-edu',
  JbPycharm: 'integrations-jb-pycharm',
  JbResharperCPlusPlus: 'integrations-jb-resharper-c-plus-plus',
  JbResharper: 'integrations-jb-resharper',
  JbRider: 'integrations-jb-rider',
  JbRubymine: 'integrations-jb-rubymine',
  JbTeamcity: 'integrations-jb-teamcity',
  JbToolboxApp: 'integrations-jb-toolbox-app',
  JbUpsource: 'integrations-jb-upsource',
  JbWebstorm: 'integrations-jb-webstorm',
  JbYoutrack: 'integrations-jb-youtrack',
  Jcb: 'integrations-jcb',
  JiraCore: 'integrations-jira-core',
  JiraOps: 'integrations-jira-ops',
  JiraServiceDesk: 'integrations-jira-service-desk',
  Jira: 'integrations-jira',
  Joomla: 'integrations-joomla',
  Jquery: 'integrations-jquery',
  Js: 'integrations-JS',
  KakaoTalk: 'integrations-kakao-talk',
  Kassa: 'integrations-kassa',
  Kayako: 'integrations-kayako',
  Kickstarter: 'integrations-kickstarter',
  Lightroom: 'integrations-lightroom',
  Line: 'integrations-line',
  Linear: 'integrations-linear',
  Linkedin: 'integrations-linkedin',
  LinuxMint: 'integrations-linux-mint',
  Linux: 'integrations-linux',
  Loom: 'integrations-loom',
  Macos: 'integrations-macos',
  Mailchimp: 'integrations-mailchimp',
  Marvel: 'integrations-marvel',
  Mastercard: 'integrations-mastercard',
  Medium: 'integrations-medium',
  Messages: 'integrations-messages',
  Messenger: 'integrations-messenger',
  Microsoft: 'integrations-microsoft',
  Music: 'integrations-music',
  Netflix: 'integrations-netflix',
  Nodejs: 'integrations-nodejs',
  Notion: 'integrations-notion',
  Npm: 'integrations-npm',
  Ok: 'integrations-OK',
  Onedrive: 'integrations-onedrive',
  Onenote: 'integrations-onenote',
  Opera: 'integrations-opera',
  Opsgenie: 'integrations-opsgenie',
  Outlook: 'integrations-outlook',
  Patreon: 'integrations-patreon',
  Paypal: 'integrations-paypal',
  Photoshop: 'integrations-photoshop',
  Php: 'integrations-php',
  Pinterest: 'integrations-pinterest',
  Playstation: 'integrations-playstation',
  Powerpoint: 'integrations-powerpoint',
  Procreate: 'integrations-procreate',
  ProductHunt: 'integrations-product-hunt',
  Python: 'integrations-python',
  Qiwi: 'integrations-qiwi',
  Quora: 'integrations-quora',
  Qzone: 'integrations-qzone',
  React: 'integrations-react',
  Reddit: 'integrations-reddit',
  Redux: 'integrations-redux',
  Rlang: 'integrations-rlang',
  Ruby: 'integrations-ruby',
  Safari: 'integrations-safari',
  Sberbank: 'integrations-sberbank',
  Sharepoint: 'integrations-sharepoint',
  Shazam: 'integrations-shazam',
  Shopify: 'integrations-shopify',
  Sketch: 'integrations-sketch',
  Skype: 'integrations-skype',
  Slack: 'integrations-slack',
  Snapchat: 'integrations-snapchat',
  Soundcloud: 'integrations-soundcloud',
  Sourcetree: 'integrations-sourcetree',
  Spectrum: 'integrations-spectrum',
  Spotify: 'integrations-spotify',
  Stackoverflow: 'integrations-stackoverflow',
  Statuspage: 'integrations-statuspage',
  Steam: 'integrations-steam',
  Stripe: 'integrations-stripe',
  StumbleUpon: 'integrations-stumble-upon',
  SublimeText: 'integrations-sublime-text',
  Swift: 'integrations-swift',
  Teams: 'integrations-teams',
  Techcrunch: 'integrations-techcrunch',
  Telegram: 'integrations-telegram',
  Things: 'integrations-things',
  Tiktok: 'integrations-tiktok',
  Tinder: 'integrations-tinder',
  Tinkoff: 'integrations-tinkoff',
  Tor: 'integrations-tor',
  Treehouse: 'integrations-treehouse',
  Trello: 'integrations-trello',
  Tripadvisor: 'integrations-tripadvisor',
  Tumbler: 'integrations-tumbler',
  Twitch: 'integrations-twitch',
  Twitter: 'integrations-twitter',
  Ubuntu: 'integrations-ubuntu',
  Uc: 'integrations-UC',
  Viber: 'integrations-viber',
  Vimeo: 'integrations-vimeo',
  Visa: 'integrations-visa',
  Vk: 'integrations-VK',
  Vscode: 'integrations-vscode',
  Vue: 'integrations-vue',
  Webmoney: 'integrations-webmoney',
  Wechat: 'integrations-wechat',
  Weebly: 'integrations-weebly',
  Weibo: 'integrations-weibo',
  WesternUnion: 'integrations-western-union',
  Whatsapp: 'integrations-whatsapp',
  Word: 'integrations-word',
  Wordpress: 'integrations-wordpress',
  Workflowy: 'integrations-workflowy',
  WorldPay: 'integrations-world-pay',
  Xbox: 'integrations-xbox',
  Xd: 'integrations-XD',
  Yammer: 'integrations-yammer',
  Yandex: 'integrations-yandex',
  Yii: 'integrations-yii',
  YoutubeMusic: 'integrations-youtube-music',
  Youtube: 'integrations-youtube',
  Zapier: 'integrations-zapier',
  Zendesk: 'integrations-zendesk',
  Zeplin: 'integrations-zeplin',
  Zoom: 'integrations-zoom'
} as const;

export type IntegrationsIcons = typeof INTEGRATIONS_ICONS;
export type IntegrationsIcon = IntegrationsIcons[keyof IntegrationsIcons];

export const PAYMENTS_ICONS = {
  Affirm: 'payments-affirm',
  Alipay: 'payments-alipay',
  Amazon: 'payments-amazon',
  Amex: 'payments-amex',
  ApplePay: 'payments-apple-pay',
  Bancontact: 'payments-bancontact',
  BitcoinCash: 'payments-bitcoin-cash',
  Bitcoin: 'payments-bitcoin',
  Bitpay: 'payments-bitpay',
  Citadele: 'payments-citadele',
  DinersClub: 'payments-diners-club',
  Discover: 'payments-discover',
  Elo: 'payments-elo',
  Ethereum: 'payments-ethereum',
  GiroPay: 'payments-giro-pay',
  GooglePay: 'payments-google-pay',
  Ideal: 'payments-ideal',
  Interac: 'payments-interac',
  Jcb: 'payments-jcb',
  Klarna: 'payments-klarna',
  Litecoin: 'payments-litecoin',
  Maestro: 'payments-maestro',
  Mastercard: 'payments-mastercard',
  Payoneer: 'payments-payoneer',
  Paypal: 'payments-paypal',
  Paysafe: 'payments-paysafe',
  Qiwi: 'payments-qiwi',
  Sepa: 'payments-sepa',
  ShopPay: 'payments-shop-pay',
  Skrill: 'payments-skrill',
  Sofort: 'payments-sofort',
  Stripe: 'payments-stripe',
  Unionpay: 'payments-unionpay',
  Verifone: 'payments-verifone',
  Visa: 'payments-visa',
  Wallet: 'payments-wallet',
  Webmoney: 'payments-webmoney',
  Wepay: 'payments-wepay'
} as const;

export type PaymentsIcons = typeof PAYMENTS_ICONS;
export type PaymentsIcon = PaymentsIcons[keyof PaymentsIcons];

export const SOCIALS_ICONS = {
  AngellistGrey: 'socials-angellist-grey',
  Angellist: 'socials-angellist',
  AppleGrey: 'socials-apple-grey',
  Apple: 'socials-apple',
  DiscordGrey: 'socials-discord-grey',
  Discord: 'socials-discord',
  DribbleGrey: 'socials-dribble-grey',
  Dribble: 'socials-dribble',
  FacebookGrey: 'socials-facebook-grey',
  Facebook: 'socials-facebook',
  FigmaGrey: 'socials-figma-grey',
  Figma: 'socials-figma',
  GithubGrey: 'socials-github-grey',
  Github: 'socials-github',
  GoogleGrey: 'socials-google-grey',
  Google: 'socials-google',
  InstagramGrey: 'socials-instagram-grey',
  Instagram: 'socials-instagram',
  LinkedinGrey: 'socials-linkedin-grey',
  Linkedin: 'socials-linkedin',
  PinterestGrey: 'socials-pinterest-grey',
  Pinterest: 'socials-pinterest',
  RedditGrey: 'socials-reddit-grey',
  Reddit: 'socials-reddit',
  SignalGrey: 'socials-signal-grey',
  Signal: 'socials-signal',
  SnapchatGrey: 'socials-snapchat-grey',
  Snapchat: 'socials-snapchat',
  TelegramGrey: 'socials-telegram-grey',
  Telegram: 'socials-telegram',
  TiktokGrey: 'socials-tiktok-grey',
  Tiktok: 'socials-tiktok',
  TumblerGrey: 'socials-tumbler-grey',
  Tumbler: 'socials-tumbler',
  TwitterGrey: 'socials-twitter-grey',
  Twitter: 'socials-twitter',
  YoutubeGrey: 'socials-youtube-grey',
  Youtube: 'socials-youtube'
} as const;

export type SocialsIcons = typeof SOCIALS_ICONS;
export type SocialsIcon = SocialsIcons[keyof SocialsIcons];

export type ImageIconType = IntegrationsIcon | PaymentsIcon | SocialsIcon;
